import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';
@Component({
  selector: 'draw',
  templateUrl: './draw.component.html',
  styleUrls: ['./draw.component.scss']
})
export class DrawComponent implements OnInit {
  dataLink = [
    {
      idLink: "5",
      name  : '5- Obligaciones',
      ruta : './step5',
    },{
      idLink: "51",
      name : '5.1 Política de prevención',
      ruta : './step5-sub1',
    },{
      idLink: "52",
      name  : '5.2 Identificar y analalizar los facotres de riesgo psicosocial',
      ruta : './step5-sub2',
    },{
      idLink: "53",
      name  : '5.3 Identificar y analizatr los factores de riesgo piscosocial',
      ruta : './step5-sub3',
    },{
      idLink: "54",
      name : '5.4 Adoptar las medidas de prevenir y coint',
      ruta : './step5-sub4',
    },{
      idLink: "55",
      name : '5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos',
      ruta : './step5-sub5'
    },{
      idLink: "56",
      name  : '5.6 Practicar exámenes médicos y evaluaciones psicológicas',
      ruta : './step5-sub6'
    },{
      idLink: "57",
      name  : '5.7 Difundir y proporcionar información a los trabajadores',
      ruta : './step5-sub7'
    },{
      name  : ' 5.8 Llevar los registros sobre:',
      ruta : './step5-sub8'
    }
  ]

  dataSubLink = [
    {
      idSubLink: "51",
      name  : '5.1 a) La prevención de los factores de riesgo psicosocial',
      ruta : './step5-sub1-a%29'
    },{
      idSubLink: "51",
      name  : '5.1 b) La prevención de la violencia laboral',
      ruta : './step5-sub1-b%29'
    },{
      idSubLink: "51",
      name  : '5.1 c) La promoción de un entorno organizacional favorable',
      ruta : './step5-sub1-c%29'
    },{
      idSubLink: "57",
      name  : 'a) La política de prevención de riesgos psicosociales',
      ruta : './step7-sub1-a%29'
    },{
      idSubLink: "57",
      name  : 'b) Las medidas adoptadas para combatir las prácticas opuestas al entorno organizacional favorable y los actos de violencia laboral',
      ruta : './step7-sub1-b%29'
    },{
      idSubLink: "57",
      name  : 'c) Las medidas y acciones de prevención y, en su caso, las acciones de control de los factores de riesgo psicosocial',
      ruta : './step7-sub1-c%29'
    },{
      idSubLink: "57",
      name  : 'd) Los mecanismos para presentar quejas por prácticas opuestas al entorno organizacional favorable y para denunciar actos de violencia laboral',
      ruta : './step7-sub1-d%29'
    },{
      idSubLink: "57",
      name  : 'e) Los resultados de la identificación y análisis de los factores de riesgo psicosocial para los centros de trabajo que tengan entre 16 y 50 trabajadores, y de la identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional tratándose de centros de trabajo de más de 50 trabajadores, y',
      ruta : './step7-sub1-e%29'
    },{
      idSubLink: "57",
      name  : 'f) Las posibles alteraciones a la salud por la exposición a los factores de riesgo psicosocial.',
      ruta : './step7-sub1-f%29'
    },{
      idSubLink: "58",
      name: "5.8 a) Los resultados de la identificación y análisis de los factores de riesgo psicosocial",
      ruta: "/step8-sub8-a%29",
    },{
      idSubLink: "58",
      name: "5.8 b) Las medidas de control adoptadas cuando el resultado de la identificación",
      ruta: "/step8-sub8-b%29",
    },{
      idSubLink: "58",
      name: "5.8 c) Los nombres de los trabajadores a los que se les practicaron los exámenes",
      ruta: "/step8-sub8-c%29",
    }
     

  ]

  constructor(private activated: ActivatedRoute) { }

  ngOnInit() {
  }

}
